import { render, staticRenderFns } from "./ClientReports.vue?vue&type=template&id=0b70b17f"
import script from "./ClientReports.vue?vue&type=script&lang=js"
export * from "./ClientReports.vue?vue&type=script&lang=js"
import style0 from "./ClientReports.vue?vue&type=style&index=0&id=0b70b17f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports